import type { V2AccountVM } from '~/composables/useRequest/requests/data-contracts';


export const useAccountStore = defineStore('accountStore', () => {
  const accountStore = ref<V2AccountVM>();

  function setAccountStore(newValue: V2AccountVM | undefined) {
    accountStore.value = newValue;
  }

  return { setAccountStore, accountStore };
});
